import { useState } from 'react';
import { PhotosUpload } from 'sellDirect/components/closingDash/closing/PhotosUpload';
import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import { isDigitalCheckoutFormValid } from 'sellDirect/helpers/closingDash/closing';
import { UnderContractOffer, ClosedOffer } from 'sellDirect/OfferContext';
import { UploadMoveOutPhotos } from 'sellDirect/components/closingDash/closing/DigitalCheckoutItems';

interface IProps {
  offer: UnderContractOffer | ClosedOffer;
  loading: boolean;
  resetableForm: IResetableFormRenderProps;
}

/**
 * Digital checkout form content.
 *
 * component-test-check-ignore
 */
export const DigitalCheckoutFormContent: React.FC<IProps> = ({ loading, offer, resetableForm }) => {
  const { onSubmit, setError } = resetableForm;
  const photolessOverride = !!offer.closingExperience?.digitalCheckout?.photolessOverride;
  const [numberOfRetries, setNumberOfRetries] = useState(0);

  const onSubmitForm = () => {
    const { isValid, isPhotoUploadComplete, photoErrors } = isDigitalCheckoutFormValid(
      resetableForm?.formState,
      photolessOverride,
    );
    if (!isPhotoUploadComplete) {
      setError('photos', photoErrors);
      setNumberOfRetries(numberOfRetries + 1);
    } else if (isValid) {
      setError('photos', undefined); // reset errors
      onSubmit();
    }
  };

  return (
    <>
      {!photolessOverride && (
        <PhotosUpload
          offer={offer}
          resetableForm={resetableForm}
          numberOfRetries={numberOfRetries}
        />
      )}
      <UploadMoveOutPhotos
        offer={offer}
        loading={loading}
        resetableForm={resetableForm}
        onSubmitForm={onSubmitForm}
      />
    </>
  );
};
